// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"329":"29739e3a772db099","366":"5d98034b28c6572f"}[chunkId] + ".js";
};